import React from "react";
import Navbar from "../components/common/navbar";
import Cart from "../components/cart/cart";
import Footer from "../components/common/footer";

const CartPage = () => {
  return (
    <div>
      <div className="md:mx-16">
        <Cart />
      </div>
      <Footer />
    </div>
  );
};

export default CartPage;
